export const state = () => ({
    pages: [],
    selectedPage: [],
    selectedPages: [],
    checkingEnabled: false,
});
